import { IIBatterUsageResponse } from "@/contract/generated/electrify-v1";

export interface IBatteryOutlook {
  data?: IIBatterUsageResponse;
}

export enum BatteryScenario {
  BATTERY_NOT_SUPPORTED = "batteryNotSupported",
  MAY_SUPPORT_BATTERY = "maySupportBattery",
  WILL_SUPPORT_BATTERY = "willSupportBattery",
  BIG_CAPACITY_TO_SUPPORT_BATTERY = "bigCapacityToSupportBattery",
}
